<template>
  <div>
    <img
      v-if="showCheckMark"
      class="modifier-group__check-mark"
      src="@/assets/images/greenCheckMarkAndCircle.svg"
      alt="Selection Complete Checkmark"
    />
    <div v-else class="modifier-group__req-indicator" :class="{ 'modifier-group__has-error': showErrorIndicator }">
      {{ status }}
    </div>
  </div>
</template>

<script>
export default {
  name: "ModifierGroupRequiredIndicator",
  props: {
    showError: Boolean,
    minLimit: Number,
    isComplete: Boolean
  },
  computed: {
    status() {
      return this.minLimit ? "Required" : "Optional";
    },
    showCheckMark() {
      return !!(this.isComplete && this.minLimit);
    },
    showErrorIndicator() {
      return this.minLimit && this.showError;
    }
  }
};
</script>

<style lang="scss" scoped>
.modifier-group {
  &__check-mark {
    margin-top: 2px;
  }

  &__req-indicator {
    background-color: rgba(136, 136, 136, 0.08);
    padding: 4px 6px;
    font-size: 14px;
    border-radius: 20px;
    color: $group-3-color-2;
  }

  &__has-error {
    color: white;
    background-color: #e40000;
  }
}
</style>
